module.exports = __webpack_public_path__ + "static/media/bouncer-logo2.60fb164b.svg";